define('responsive-game-feed/app/scripts/views/Video',['require','exports','module','hogan/web/builds/3.0.2/hogan-3.0.2.min.amd','../utils/Utils','../utils/tracking-gameday','../utils/tracking-omniture','gameday-language/gameday-language','gameday-social-sharing/app/gameday-social-sharing','gameday-resource-path/gameday-resource-path'],function(require, exports, module) {

    'use strict';

    var hogan = require("hogan/web/builds/3.0.2/hogan-3.0.2.min.amd");
    var Utils = require("../utils/Utils");
    var TrackingGD = require("../utils/tracking-gameday");
    var TrackingOM = require("../utils/tracking-omniture");
    var TrackingLib = {
        gameday: TrackingGD,
        omniture: TrackingOM
    };
    var gamedayLanguage = require("gameday-language/gameday-language");
    var gamedaySocialSharing = require("gameday-social-sharing/app/gameday-social-sharing");
    var Tracking;
    var ratio = 0.55;
    var resourcePath = require("gameday-resource-path/gameday-resource-path");
    var mediaKey; 
    var getMedia = function(arr) {
   
    
      for (var i = 0; i < arr.length; i++) {
         if (arr[i]["playback-scenario"] === mediaKey) {
            return arr[i]._;
         }
      }
    }




    /**
     * CLASS DESCRIPTION
     *
     * @param NAME {TYPE} PARAM DESCRIPTION
     * @return {TYPE} RETURN DESCRIPTION
     */
    function VideoView(cfg) {
        this.element = cfg.element;
        this.model;
        Tracking = TrackingLib[Utils.options.tracking];
    }

    VideoView.prototype = {


        render: function(cfg) {
            var that = this;
            var model = cfg.model;
            var data = this.preCleanData(model);
            this.model = data;
            var template = hogan.compile(cfg.template);
            var thumb = Utils.getImageByType(model.data.thumbnails.thumb, 43);
            
            if (Utils.options.language === 'es' && model.data_es) {
                 this.model.data.headline = model.data_es.headline;     
            }
            
            if (!mediaKey) {
             mediaKey = (!Utils.options.deviceType) ? 'FLASH_1200K_640X360' : 'HTTP_CLOUD_MOBILE';
            } 
            
            this.model.data.shareLink = resourcePath.get("shareVideoLink",{cid : model.data.id});
            
            var vcfg = {
                model: model,
                thumb: thumb,
                gid: Utils.options.gid,
                murl: getMedia(model.data.url),
                mustacheLanguage: gamedayLanguage(Utils.options.language)
            };
            
           
           
            if (!Utils.options.deviceType) {
                vcfg.sponsor = true;
            }
            var html = template.render(vcfg);
            Utils.insertItem(this.element, model, html);

            var vidElement = $("#" + this.model.guid);
            var vidThumbDiv = vidElement.find(".video-thumb");
            var videoId = vidThumbDiv.attr("data-vid");
            var videoHeadline = vidThumbDiv.attr("data-headline");
            var surl = "http://m.mlb.com/video/v" + videoId;
            var deviceInteraction = Utils.options.deviceInteraction;
            var vcContent= vidElement.find(".video-content-container");
            var nativeJsonData = {
                url: surl,
                id: videoId
            }
            var shareJsonData = {
                title: videoHeadline,
                id: videoId
            }
            
            
            // BIND PLAY BUTTON
            vidElement.find(".video-thumb").on("click", function(e) {
                e.stopPropagation();
                var data = $(this).data();
                if (!deviceInteraction.video(data)) {
                    that.playVideo(e);
                }
            });

            $(cfg.feedView).trigger("renderCBTracker_" + cfg.model.guid, cfg.model.guid);
            
            if (!Utils.options.sharingEnable) {
              return false;
            } 

            var sharing = new gamedaySocialSharing({
                target: vidElement,
                aId: videoId,
                url: surl,
                title: videoHeadline,
            });

            sharing.createShareBtn();

            $(sharing).on(sharing.events.GD_SHARE_ON, function(e) {
                vcContent.removeClass("toRight").addClass("toLeft");
            }).on(sharing.events.GD_SHARE_OFF, function(e) {
                vcContent.removeClass("toLeft").addClass("toRight");                            
            });


            // BIND SHARE BUTTON
            vidElement.find(".share-btn").on("click", function(e) {
                e.stopPropagation();
                var currentShareBtn = $(this);
                var socialDiv = vidElement.find(".bam-social-container");

                if (!deviceInteraction.share(shareJsonData)) {
                    sharing.init();
                }
            });
            



        },

        preCleanData: function(model) {
            var type = model.data["media-type"];

            if (model.data.hasOwnProperty("media-type")) {

                if (type === 'M' || type === 'N') {
                    return model;
                }

                delete model.data["media-type"];
                return model;
            }
        },


        addVideo: function(target) {
            var that = this;
            var thumbDiv = $(target);
            var itemDiv = thumbDiv.parent();
            var containerDiv = itemDiv.parent();
            var baseId = itemDiv.attr("id");
            var murl = thumbDiv.attr("data-url");
            var vid = thumbDiv.attr("data-vid");
            var vidTag = "<div class='feed-item row video' style='text-align:center;' id='" + baseId + "-overlay'><div class='glyphicon glyphicon-remove close-video'></div><iframe src='http://mlb.com/shared/video/embed/embed.html?path=" + murl + "&width=270&height=151&property=mlb&content_id=" + vid + "&disableEndSlate=true' width='270' height='151' frameborder='0'>Your browser does not support iframes.</iframe></div>";
            containerDiv.prepend(vidTag);
            $("#" + baseId).hide();
            containerDiv.find(".close-video").on("click", function() {
                that.removeVideo.call(this, baseId);
            });
        },


        createVideo: function(target) {

            var that = this;
            var thumbDiv = $(target);
            var itemDiv = thumbDiv.parent();
            $(".video-frame").css("display", "none");
            Utils.options.vContainerDiv = itemDiv.parent();
            var baseId = itemDiv.attr("id");
            var murl = thumbDiv.attr("data-url");
            var vid = thumbDiv.attr("data-vid");
            var width = Utils.options.vContainerDiv.find(".video-thumb").width();
            var height = width * ratio;
            var vidTag = "<iframe src='http://mlb.com/shared/video/embed/embed.html?path=" + murl + "&width=" + width + "&height=" + height + "&property=mlb&content_id=" + vid + "&disableEndSlate=true' width='" + width + "' height='" + height + "' frameborder='0'>Your browser does not support iframes.</iframe>";
            Utils.options.vContainerDiv.find(".video-thumb").hide().end().find(".video-frame").html(vidTag).css("display", "inline-block");

        },


        play: function(event) {

            Tracking.track_color_feed_video_click();
            if (Utils.options.videoInline) {
                this.addVideo(event.currentTarget);
            }
        },

        resetVideos: function() {
            this.element.find(".feed-item.video .video-frame").empty().end().find(".feed-item.video .video-thumb").show();
        },

        playVideo: function(event) {
            this.resetVideos();
            Tracking.track_color_feed_video_click();
            if (Utils.options.videoInline) {
                this.createVideo(event.currentTarget);
            }
        },

        removeVideo: function(baseId) {
            $("#" + baseId + "-overlay").remove();
            $("#" + baseId).show();
        },

        events: {
            "click .video-thumb": "play",
            "click .close-video": "removeVideo"
        }


    };

    return VideoView;

});
